import {ResponseDto} from '../dto/ResponseDto';
import {MessageViewModel} from './MessageViewModel';
import {ClientFileMessage} from '../service/client-file.message';

export class MessageViewModelFactory {

    private static messageIdCounter: number = 0;

    public static createFromServerDto(dto: ResponseDto, shouldSmoothScrollToBottomAfterRendering?: boolean): MessageViewModel {
        const viewModel = new MessageViewModel(MessageViewModelFactory.getNextId());
        // Data can be any

        viewModel.data = dto.data;
        viewModel.type = dto.type;
        viewModel.sender = 'server';
        viewModel.quickReplies = dto.quickReplies;
        if (dto.date !== undefined) {
            viewModel.date = new Date(dto.date);
        }
        if (dto.webSocketSpecificData?.botResultOptions?.outputOptions?.botAvatarImageUrl !== undefined) {
            viewModel.botAvatarImageUrl = dto.webSocketSpecificData?.botResultOptions?.outputOptions.botAvatarImageUrl;
        }
        if (shouldSmoothScrollToBottomAfterRendering !== undefined) {
            viewModel.shouldSmoothScrollToBottomAfterRendering = shouldSmoothScrollToBottomAfterRendering;
        }
        return viewModel;
    }

    public static createFromClientText(text: string, shouldSmoothScrollToBottomAfterRendering?: boolean, attachmentName?: string): MessageViewModel {
        const viewModel = new MessageViewModel(MessageViewModelFactory.getNextId());
        viewModel.data = {text: text, attachmentName: attachmentName};
        viewModel.type = 'text';
        viewModel.sender = 'client';
        if (shouldSmoothScrollToBottomAfterRendering !== undefined) {
            viewModel.shouldSmoothScrollToBottomAfterRendering = shouldSmoothScrollToBottomAfterRendering;
        }
        return viewModel;
    }

    public static createFromClientFiles(files: ClientFileMessage): MessageViewModel {
        const viewModel = new MessageViewModel(MessageViewModelFactory.getNextId());
        viewModel.data = files;
        viewModel.type = 'files';
        viewModel.sender = 'client';
        return viewModel;
    }

    public static createTypingIndicator(): MessageViewModel {
        const viewModel = new MessageViewModel(MessageViewModelFactory.getNextId());
        viewModel.type = 'typingindicator';
        viewModel.sender = 'server';
        return viewModel;
    }

    public static createThinkingIndicator(): MessageViewModel {
        const viewModel = new MessageViewModel(MessageViewModelFactory.getNextId());
        viewModel.type = 'thinkingindicator';
        viewModel.sender = 'server';
        return viewModel;
    }

    public static createNewMessagesDivider(): MessageViewModel {
        const viewModel = new MessageViewModel(MessageViewModelFactory.getNextId());
        viewModel.type = 'new-messages-divider';
        viewModel.sender = 'divider';
        viewModel.shouldSmoothScrollToBottomAfterRendering = false;
        return viewModel;
    }

    private static getNextId(): number {
        MessageViewModelFactory.messageIdCounter++;
        return MessageViewModelFactory.messageIdCounter;
    }
}
